const encrypt = str => {
  if (process.env.NODE_ENV !== 'production') {
    return str;
  }

  let hash = 0;

  if (str.length === 0) {
    return btoa(`${hash}`);
  }

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return btoa(`${hash}`);
};

export function saveToStorage(key, value) {
  const k = encrypt(key);

  if (value) {
    localStorage.setItem(k, JSON.stringify(value));
  } else {
    localStorage.removeItem(k);
  }
}

export function loadFromStorage(key) {
  const k = encrypt(key);
  const value = localStorage.getItem(k);
  return value && JSON.parse(value);
}
